import { render, staticRenderFns } from "./OrgMonitorReports.vue?vue&type=template&id=3f402622"
import script from "./OrgMonitorReports.vue?vue&type=script&lang=js"
export * from "./OrgMonitorReports.vue?vue&type=script&lang=js"
import style0 from "./OrgMonitorReports.vue?vue&type=style&index=0&id=3f402622&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports